import { useCampaign } from "@/context/CampaignContext";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { formatDistanceToNow } from "date-fns";
import { PlusCircle, Eye } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { fetchUserCampaigns } from "../../Redux/ReduxSlices/campaignSlice";

export default function CampaignsList() {
  const { campaigns } = useSelector((state) => state.campaign);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchUserCampaigns());
  }, [dispatch]);

  const formatDate = (dateString) => {
    if (!dateString) return "-";

    const date = new Date(dateString);
    return date.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "active":
        return "bg-green-100 text-green-800 hover:bg-green-200 ";
      case "completed":
        return "bg-blue-100 text-blue-800 hover:bg-blue-200 ";
      case "paused":
        return "bg-yellow-100 text-yellow-800 hover:bg-yellow-200 ";
      case "draft":
        return "bg-gray-100 text-gray-800 hover:bg-gray-200 ";
      case "replied":
        return "bg-green-100 text-green-800 hover:bg-green-200 ";
      case "clicked":
        return "bg-blue-100 text-blue-800 hover:bg-blue-200 ";
      case "opened":
        return "bg-yellow-100 text-yellow-800 hover:bg-yellow-200 ";
      case "delivered":
        return "bg-gray-100 text-gray-800 hover:bg-gray-200 ";
      case "failed":
        return "bg-red-300 text-red-800 hover:bg-red-400 ";
      case "queued":
        return "bg-yellow-500 text-black hover:bg-yellow-600 ";
      case "sending":
        return "bg-blue-400 text-black hover:bg-blue-600 text-sm";
      default:
        return "bg-gray-300 text-gray-900 hover:bg-gray-200 ";
    }
  };
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h2 className="text-lg font-medium">Your Campaigns</h2>
        <Button
          size="sm"
          onClick={() => navigate("/search")}
          className="main-button"
        >
          <PlusCircle className="h-4 w-4 mr-1" /> New Campaign
        </Button>
      </div>

      {campaigns?.length === 0 ? (
        <div className="text-center py-10">
          <p className="text-sm text-muted-foreground">
            You haven't created any campaigns yet.
          </p>
          <Button
            variant="outline"
            className="mt-4 main-button text-white"
            onClick={() => navigate("/search")}
          >
            <PlusCircle className="h-4 w-4 mr-1" /> Create Your First Campaign
          </Button>
        </div>
      ) : (
        <div className="border rounded-md">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Name</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Recipients</TableHead>

                <TableHead>Created</TableHead>
                <TableHead className="text-right">Actions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {campaigns.map((campaign) => (
                <TableRow key={campaign.id}>
                  <TableCell className="font-medium max-md:text-sm">
                    {campaign.campaign_name}
                  </TableCell>
                  <TableCell>
                    <Badge className={getStatusColor(campaign.status)}>
                      {campaign.status.charAt(0).toUpperCase() +
                        campaign.status.slice(1)}
                    </Badge>
                  </TableCell>
                  <TableCell className="max-md:text-sm">{campaign.total_recipients}</TableCell>

                  <TableCell className="max-md:text-sm">{formatDate(campaign.created_at + "Z")}</TableCell>
                  <TableCell className="text-right">
                    <Button
                      size="sm"
                      variant="ghost"
                      className="h-8 w-8 p-0"
                      onClick={() => navigate(`/campaign/${campaign.id}`)}
                    >
                      <Eye className="h-4 w-4" />
                      <span className="sr-only">View</span>
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  );
}
